import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { HttpHeaders, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocationService } from './location.service';
import { map } from 'rxjs/operators';

export interface HttpOptionsInterface {
  observe: 'body';
  headers: HttpHeaders;
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class HttpOptionsService {
  constructor(
    private locationService: LocationService,
    private tokenService: TokenService,
  ) {
  }

  public getOptions(useToken: boolean, withCredentials = false, params?: NestedDictionary<string>, responseType?: string): Observable<HttpOptionsInterface> {
    return this.getHeaders(useToken, params)
      .pipe(
        map((headers: HttpHeaders) => {
          const extraOptions: HttpOptionsInterface = { observe: 'body', headers };

          extraOptions.withCredentials = withCredentials;
          if (params) {
            extraOptions.params = this.getParams(params);
          }
          if (responseType) {
            extraOptions.responseType = responseType;
          }

          return extraOptions;
        }),
      );
  }

  private getParams(params: NestedDictionary<string>): HttpParams {
    let httpParams = new HttpParams({
      encoder: new MyCustomHttpUrlEncodingCodec(),
    });

    Object.entries(params).forEach(
      ([key, value]) => {
        if (key === 'headers') {
          return;
        }

        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            httpParams = httpParams.append(key + '[' + i + ']', value[i] as string);
          }
        } else {
          httpParams = httpParams.append(key, value as string);
        }
      },
    );
    return httpParams;
  }

  private getHeaders(useToken: boolean, params?: NestedDictionary<string | null>): Observable<HttpHeaders> {
    return this.tokenService.getToken()
      .pipe(
        map((token: string) => {
          let headers = new HttpHeaders();

          headers = headers.append('Accept-Language', this.locationService.getApiLanguageCode());
          if (useToken && token) {
            headers = headers.append('x-auth-token', token);
          }

          if (!!params && typeof params === 'object') {
            Object.entries(params).forEach(
              ([key, value]) => {
                if (key === 'headers') {
                  if (value) {
                    Object.entries(value).forEach(
                      ([key1, value1]) => {
                        if (value1) {
                          headers = headers.append(key1, value1?.toString());
                        }
                      },
                    );
                  }
                }
              },
            );
          }

          return headers;
        }),
      );
  }
}

class MyCustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  override encodeKey(k: string): string {
    return super.encodeKey(k)
      .replace(new RegExp('%5B', 'g'), '[')
      .replace(new RegExp('%5D', 'g'), ']');
  }
}
